import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { DigitalCard } from '../components/carte/DigitalCard';
import { FamilySection } from '../components/carte/FamilySection';
import { PetsSection } from '../components/carte/PetsSection';
import { ConsentDialog, EditCardDialog } from '../components/carte/EditCardDialog';
import type { FamilyMember } from '../data/carte';
export function MaCarte() {
  const [memberId, setMemberId] = useState('bryon');
  const [editing, setEditing] = useState<FamilyMember | null>(null);
  const [consent, setConsent] = useState<FamilyMember | null>(null);
  const openEdit = (member: FamilyMember) => {
    if (member.canEdit) setEditing(member);else setConsent(member);
  };
  return <main className="bg-white" data-id="element-1966" data-mp="1nzm02r2hb6xu">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-1967" data-mp="1o2i0qn5po9pz">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-1968" data-mp="1sxx94zky9df0">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-blue" data-id="element-1969" data-mp="2pukjalv0cs7f">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1970" data-mp="2lro4754ofe88" />
          <span aria-current="page" data-id="element-1971" data-mp="2gsup589qrf5y">My Card</span>
        </nav>

        <header className="mt-4" data-id="element-1972" data-mp="2bvujuzkpugfw">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-1973" data-mp="2but6gog89hv0">My Card</h1>
          <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-slate-600" data-id="element-1974" data-mp="26xt3wnil6x8n">
            Your digital citizen card gets you into Town services, for you and for the members of your family.
          </p>
        </header>

        <div className="mt-10 grid gap-10 lg:grid-cols-[minmax(0,460px)_minmax(0,1fr)] lg:gap-14" data-id="element-1975" data-mp="1y1k06wnktcgp">
          <DigitalCard memberId={memberId} onEdit={openEdit} data-id="element-1976" data-mp="1t30emxcwa2ov" />
          <div data-id="element-1977" data-mp="1o58n44g5wil7">
            <FamilySection selectedId={memberId} onSelect={setMemberId} data-id="element-1978" data-mp="1o4yyolarmjhm" />
            <PetsSection data-id="element-1979" data-mp="1j7ypi1imd0ma" />
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-1980" data-mp="19iic2bcmzbmf">
        {editing && <EditCardDialog member={editing} onClose={() => setEditing(null)} data-id="element-1981" data-mp="19i9ui65kji4w" />}
      </AnimatePresence>
      <AnimatePresence data-id="element-1982" data-mp="1ejpjuaes4at3">
        {consent && <ConsentDialog member={consent} onClose={() => setConsent(null)} data-id="element-1983" data-mp="1efs0bnoahh8o" />}
      </AnimatePresence>
    </main>;
}